<template>
  <div class="device_none">
    <div class="device_none_notice" v-if="loadingContent.length == 0">
      <div class="notice_title_box">
        <div class="notice_icon"></div>
        <div class="notice_title">
          {{ $t('guide_title', { brand: $t(brandTitle) }) }}
        </div>
      </div>
      <div class="notice_content">
        <div class="notice_step">
          <img src="@/assets/img/empty_1.png" />
          <div class="notice_text">
            <span class="num_icon">1</span>
            <span v-html="$t('guide1')"></span>
          </div>
        </div>
        <div class="notice_step">
          <img src="@/assets/img/empty_2.png" />
          <div class="notice_text">
            <span class="num_icon">2</span>
            <span v-html="$t('guide2')"></span>
          </div>
        </div>
      </div>
      <div class="notice_confirm text_white_gradient_bg" @click="closeWindow">{{ $t('close') }}</div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { onMounted, ref } from 'vue'
import { getBrandTitle } from '@/brand/brand'
import { loadingContent } from '../loading/loading.vue'
const closeWindow = () => electronAPI.close()
const brandTitle = ref<string>('')

onMounted(async () => {
  brandTitle.value = await getBrandTitle()
})
</script>
<style lang="less" scoped>
.device_none {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.6);
  pointer-events: none;
  z-index: 2;

  .device_none_notice {
    -webkit-app-region: no-drag;
    padding: 40px 50px 0 50px;
    width: 680px;
    height: 740px;
    background-color: #fff;
    border-radius: var(--radius-l);
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;

    .notice_title_box {
      display: flex;
      align-items: center;

      .notice_title {
        font-size: 24px;
        color: #000;
        margin-left: 10px;
      }

      .notice_icon {
        width: 28px;
        height: 28px;
        background: url('@/assets/img/icon_failed_red.png') no-repeat;
      }
    }

    .notice_content {
      width: 561px;

      .notice_step {
        display: flex;
        align-items: center;
        flex-flow: row;
        justify-content: center;

        :first-child {
          margin-bottom: 46px;
        }

        img {
          padding: auto 34px;
        }
      }
    }

    .notice_text {
      font-size: 14px;
      color: #888;
      display: flex;
      justify-content: center;
      margin-left: 54px;

      :last-child {
        margin-left: 12px;
      }

      .num_icon {
        background-color: #707070;
        height: 20px;
        border-radius: var(--radius-s);
        color: white;
        text-align: center;
        font-size: 14px;
        padding: 1px 6px;
        line-height: 20px;
      }
    }

    .notice_desc1 {
      font-size: 12px;
      color: #888;
      text-align: center;
      line-height: 20px;
    }

    .notice_confirm {
      width: 120px;
      height: 40px;
      color: #fff;
      border-radius: var(--radius-m);
      font-size: 18px;
      text-align: center;
      line-height: 40px;
      cursor: pointer;
      pointer-events: auto;
    }
  }
}
</style>
